module.exports = __webpack_public_path__ + "static/media/ICONO-ESTRELLAS-IA-blanco.3b89be92.png";